import {
  Col,
  Form,
  Row,
} from "antd";
import { useEffect, useState } from "react";
import {
  getLoyalty,
} from "../../repository/data.repository";
import { retry } from "../../utils/http";
import DynamicForm from "../../controls/DynamicForm";
import _ from "lodash";
import dayjs from "dayjs";
import InModal from "../../controls/InModal";

export interface LoyaltyViewProps {
  readonly open?: boolean;
  readonly uid: string;
  readonly onCancel?: () => void;
}

function LoyaltyView(props: LoyaltyViewProps) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (props.open) {
      setLoading(true);
      retry(() =>
        getLoyalty(props.uid),
      ).then((data) => {
        setLoading(false);
        form.setFieldsValue(data);
      })
    } else {
      reset();
    }
  }, [props.open]);

  // Events

  function onCancel(): void {
    props.onCancel?.();
  }

  // Methods

  function reset(): void {
    setLoading(false);
    form.resetFields();
  }

  return (
    <InModal
      open={props.open}
      onCancel={onCancel}
      title="Loyalty History"
      actions={[]}
      size="medium"
    >
        <Row className="mb-4 flex flex-row">
          <Col className="flex flex-1 flex-col">
            <DynamicForm
              className="w-full"
              form={form}
              preview={true}
              schema={{
                groups: [
                  {
                    controls: [
                      {
                        type: "labelbox",
                        name: "userUserName",
                        label: "User Name",
                      },
                      {
                        type: "labelbox",
                        name: "pointsChange",
                        label: "Points",
                      },
                      {
                        type: "labelbox",
                        name: "description",
                        label: "Description",
                      },
                      {
                        type: "labelbox",
                        name: "rewardName",
                        label: "Reward",
                      },
                      {
                        type: "labelbox",
                        name: "companyName",
                        label: "Company",
                      },
                      {
                        type: "labelbox",
                        name: "tenantName",
                        label: "Tenant",
                      },
                      {
                        type: "labelbox",
                        name: "createdOn",
                        label: "Created On",
                        format: (value) =>
                          dayjs(value).format("DD/MM/YYYY HH:mm"),
                      },
                      {
                        type: "labelbox",
                        name: "createdByUserUserName",
                        label: "Created By",
                      },
                      {
                        type: "labelbox",
                        name: "updatedOn",
                        label: "Updated On",
                      },
                      {
                        type: "labelbox",
                        name: "updatedByUserUserName",
                        label: "Updated By",
                      },
                    ],
                  },
                ],
              }}
            />
          </Col>
        </Row>
    </InModal>
  );
}

export default LoyaltyView;
